import React from 'react';
import { useTranslation } from 'react-i18next';
import AzureFileUploadDrawer from '../../Commons/AzureFileUploadDrawer/AzureFileUploadDrawer.Component';
import { SERVICE_ALLOWED_FILE_TYPES } from '../../../functions/AzureFileUpload.Functions';
import { AzureFileTarget } from '../../../models/Entities/AzureFiles/AzureFileUpload';
import { Service } from '../../../models/Entities/Service';

export interface ServiceReceiptsDrawerProps {
  open: boolean;
  onDismiss: () => void;
  service: Pick<Service, 'id' | 'description'> | undefined;
  /** Receipts target of the service (built with getServiceReceiptTarget); nothing renders without it */
  target: AzureFileTarget | undefined;
  /** Files dropped over the service row before opening */
  initialFiles?: File[];
}

/**
 * Receipts of a service (contract §10.4): the shared upload drawer with the ServiceReceipt type, the service
 * GUID as entity key and the sponsor + protocol owner. Upload, list, preview, link and unlink come from it.
 */
export const ServiceReceiptsDrawer = ({ open, onDismiss, service, target, initialFiles }: ServiceReceiptsDrawerProps) => {
  const { t } = useTranslation();
  if (!service || !target) return null;
  const description = service.description?.trim() || t('serviceReceipts.untitled');
  return (
    <AzureFileUploadDrawer
      open={open}
      onDismiss={onDismiss}
      title={t('serviceReceipts.drawerTitle', { description })}
      target={target}
      allowedFileTypes={SERVICE_ALLOWED_FILE_TYPES}
      initialFiles={initialFiles}
      fileListLoader="service"
      allowMultiple
    />
  );
};

export default ServiceReceiptsDrawer;
